// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solutionsContainer_NQZql {
    width: 100%;
    display: none;
    background-color: var(--white-background);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 1;
    overflow: scroll;
    gap: 30px;
    position: fixed;
    top: 50px;
    right: 0px;
    @media (width<=1000px) {
      top: 0;

    }

    @media (width>=1000px) {

      &:hover {
        display: flex;
      }
    }

    .container_aoRHM {
      height: calc(100vh - 50px);
      overflow: scroll;
      margin: 0 auto;
      @media (width<=1000px) {
        height: 100vh;
      }
    }

    .content_niQ8y {
      margin: 0px auto;
      width: 97vw;  
      background-color: #f5f5f574;
      padding: 10px;
      border-radius: 8px;
      box-sizing: border-box;
      .headerSolution_P_aHD{
        margin: 10px 0;
        display: flex;
        align-items: center;
        gap: 10px;

        span {
          display: inline-block;
          color: #737373;
        }

        >p {
          margin: 0;
          color: #666666;
          background-color: #2222223c;
          padding: 6px 8px ;
          border-radius: 999px;
        }

        @media (width<=528px) {
          flex-direction: column;
        }
      }
    }


    .solutionCard_wDg6Q {
      background-color: var(--f1-background);
      padding: 10px;
      border-radius: 8px;
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;

      &:hover{
        .infoSolution_j0ZRl{
          h3{
            text-transform: capitalize;
          }
        }
      }

            button{
              background-color: #E7E7E7;
              color: var(--_71717a-color);
            }

            &:hover{
              button{
                background-color: var(--_10a37f-background);
                color: var(--white-background);
              }
            }

      .infoSolution_j0ZRl {
        display: flex;
        align-items: center;
        gap: 10px;

        svg {
          width: 20px;
          height: 20px;
        }

        h3 {
          margin: 0;
          color: #09090b;
          font-weight: 400;
          font-size: 16px;
          text-transform: capitalize;
        }
      }

      p {
        font-size: 13px;
        margin: 0px 0px 4px;
      }
    }

    .solutionsList_AQmHM {
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(1, 1fr);
    }

    @media (min-width: 640px) {
      .solutionsList_AQmHM {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (min-width: 768px) {
      .solutionsList_AQmHM {
        grid-template-columns: repeat(3,
            1fr);
        &.bottom_EOJwx{
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    @media (min-width: 1024px) {
      .solutionsList_AQmHM {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Navbar/SaaS/SaaS.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,SAAS;IACT,UAAU;IACV;MACE,MAAM;;IAER;;IAEA;;MAEE;QACE,aAAa;MACf;IACF;;IAEA;MACE,0BAA0B;MAC1B,gBAAgB;MAChB,cAAc;MACd;QACE,aAAa;MACf;IACF;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,2BAA2B;MAC3B,aAAa;MACb,kBAAkB;MAClB,sBAAsB;MACtB;QACE,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET;UACE,qBAAqB;UACrB,cAAc;QAChB;;QAEA;UACE,SAAS;UACT,cAAc;UACd,2BAA2B;UAC3B,iBAAiB;UACjB,oBAAoB;QACtB;;QAEA;UACE,sBAAsB;QACxB;MACF;IACF;;;IAGA;MACE,sCAAsC;MACtC,aAAa;MACb,kBAAkB;MAClB,oBAAoB;MACpB,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;;MAER;QACE;UACE;YACE,0BAA0B;UAC5B;QACF;MACF;;YAEM;cACE,yBAAyB;cACzB,2BAA2B;YAC7B;;YAEA;cACE;gBACE,2CAA2C;gBAC3C,8BAA8B;cAChC;YACF;;MAEN;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET;UACE,WAAW;UACX,YAAY;QACd;;QAEA;UACE,SAAS;UACT,cAAc;UACd,gBAAgB;UAChB,eAAe;UACf,0BAA0B;QAC5B;MACF;;MAEA;QACE,eAAe;QACf,mBAAmB;MACrB;IACF;;IAEA;MACE,aAAa;MACb,SAAS;MACT,qCAAqC;IACvC;;IAEA;MACE;QACE,qCAAqC;MACvC;IACF;;IAEA;MACE;QACE;gBACQ;QACR;UACE,qCAAqC;QACvC;MACF;IACF;;IAEA;MACE;QACE,qCAAqC;MACvC;IACF;EACF","sourcesContent":[".solutionsContainer {\n    width: 100%;\n    display: none;\n    background-color: var(--white-background);\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    z-index: 1;\n    overflow: scroll;\n    gap: 30px;\n    position: fixed;\n    top: 50px;\n    right: 0px;\n    @media (width<=1000px) {\n      top: 0;\n\n    }\n\n    @media (width>=1000px) {\n\n      &:hover {\n        display: flex;\n      }\n    }\n\n    .container {\n      height: calc(100vh - 50px);\n      overflow: scroll;\n      margin: 0 auto;\n      @media (width<=1000px) {\n        height: 100vh;\n      }\n    }\n\n    .content {\n      margin: 0px auto;\n      width: 97vw;  \n      background-color: #f5f5f574;\n      padding: 10px;\n      border-radius: 8px;\n      box-sizing: border-box;\n      .headerSolution{\n        margin: 10px 0;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        span {\n          display: inline-block;\n          color: #737373;\n        }\n\n        >p {\n          margin: 0;\n          color: #666666;\n          background-color: #2222223c;\n          padding: 6px 8px ;\n          border-radius: 999px;\n        }\n\n        @media (width<=528px) {\n          flex-direction: column;\n        }\n      }\n    }\n\n\n    .solutionCard {\n      background-color: var(--f1-background);\n      padding: 10px;\n      border-radius: 8px;\n      display: inline-flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 2px;\n\n      &:hover{\n        .infoSolution{\n          h3{\n            text-transform: capitalize;\n          }\n        }\n      }\n\n            button{\n              background-color: #E7E7E7;\n              color: var(--_71717a-color);\n            }\n\n            &:hover{\n              button{\n                background-color: var(--_10a37f-background);\n                color: var(--white-background);\n              }\n            }\n\n      .infoSolution {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        svg {\n          width: 20px;\n          height: 20px;\n        }\n\n        h3 {\n          margin: 0;\n          color: #09090b;\n          font-weight: 400;\n          font-size: 16px;\n          text-transform: capitalize;\n        }\n      }\n\n      p {\n        font-size: 13px;\n        margin: 0px 0px 4px;\n      }\n    }\n\n    .solutionsList {\n      display: grid;\n      gap: 10px;\n      grid-template-columns: repeat(1, 1fr);\n    }\n\n    @media (min-width: 640px) {\n      .solutionsList {\n        grid-template-columns: repeat(2, 1fr);\n      }\n    }\n\n    @media (min-width: 768px) {\n      .solutionsList {\n        grid-template-columns: repeat(3,\n            1fr);\n        &.bottom{\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n    }\n\n    @media (min-width: 1024px) {\n      .solutionsList {\n        grid-template-columns: repeat(4, 1fr);\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"solutionsContainer": `solutionsContainer_NQZql`,
	"container": `container_aoRHM`,
	"content": `content_niQ8y`,
	"headerSolution": `headerSolution_P_aHD`,
	"solutionCard": `solutionCard_wDg6Q`,
	"infoSolution": `infoSolution_j0ZRl`,
	"solutionsList": `solutionsList_AQmHM`,
	"bottom": `bottom_EOJwx`
};
export default ___CSS_LOADER_EXPORT___;
